import PropTypes from 'prop-types'

import PermanentDrawer from './PermanentDrawer'
import TemporaryDrawer from './TemporaryDrawer'

/**
 * Renders a drawer component that contains a temporary drawer and a permanent drawer.
 *
 * @author Maria Eduarda Franke
 * @param {string} selectedKey - The selected key for the drawer.
 * @returns {JSX.Element} The rendered drawer component.
 */
const Drawer = ({ selectedKey }) => {

    return (
        <>
            <TemporaryDrawer selectedKey={selectedKey} />
            <PermanentDrawer selectedKey={selectedKey} />
        </>
    )
}

Drawer.propTypes = {
    selectedKey: PropTypes.string.isRequired
}

export default Drawer